var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaotalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Kakaotalk"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C4.58478 2 1 6.48339 1 10.2764C1 13.1185 2.90422 15.6254 5.80456 17.1151L4.58478 21.4564C4.476 21.8413 4.927 22.1468 5.27289 21.9254L10.6226 18.4853C11.0736 18.5279 11.5331 18.5528 12 18.5528C18.0744 18.5528 23 14.8474 23 10.2764C23 6.48339 19 2 12 2Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaotalk);
export default __webpack_public_path__ + "static/media/Kakaotalk.cdaa56cb1c51ad664170acb283dace5f.svg";
export { ForwardRef as ReactComponent };